export default __webpack_public_path__ + "static/media/2color.1d258d5d.png";